// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-bold-text-82e973dc"};